// extracted by mini-css-extract-plugin
export default {"placeholder":"LazyLoading_placeholder__wzdfy","container":"LazyLoading_container__DmAmM"};